
export default {
  shipping_methods:{
    'AAA COOPER' : 'AAA Cooper',
    'AVERITT' : 'Averitt',
    'ESTES' : 'Estes',
    'FED EX FREIGHT' : 'FedEx',
    'FEDERAL EXPRESS 2ND DAY AIR' : 'FedEx',
    'FEDERAL EXPRESS GROUND' : 'FedEx',
    'FEDERAL EXPRESS PRIORITY AIR' : 'FedEx',
    'Federal Express Priority Saturday Delive' : 'FedEx',
    'FEDEX INTERNATIONAL PRIORITY' : 'FedEx',
    'FED-X NEXT DAY AIR' : 'FedEx',
    'HOLLAND' : 'USF Holland',
    'OLD DOMINION' : 'Old Dominion',
    'SAIA' : 'SAIA',
    'SOUTH EASTERN' : 'Southeastern Freight',
    'UPS 2ND DAY AIR' : 'UPS',
    'UPS 3 DAY SELECT' : 'UPS',
    'UPS AIR FREIGHT' : 'UPS',
    'UPS FREIGHT' : 'UPS',
    'UPS GROUND' : 'UPS',
    'UPS INTERNATIONAL EXPRESS' : 'UPS',
    'UPS NEXT DAY AIR' : 'UPS',
    'UPS NEXT DAY EARLY AM' : 'UPS',
    'UPS NEXT DAY SAT DELIVERY' : 'UPS',
    'UPS SUPPLY CHAIN SOLUTIONS' : 'UPS',
    'VOLUNTEER EXPRESS' : 'Volunteer Express',
    'YELLOW/ROADWAY' : 'Roadway Express'
  },

  getTrackingLink : function(carrier, tracking){
    var time = new Date().getTime();
    
    switch(this.shipping_methods[carrier]){
      case 'AAA Cooper':
        return 'http://www.aaacooper.com/Transit/ProTrackResults.aspx?ProNum=' + tracking + '&AllAccounts=tru';
        break;
      case 'SAIA':
        return null;
        break;
      case 'Averitt':
        return 'https://www.averittexpress.com/trackLTLById.avrt?serviceType=LTL&resultsPageTitle=LTL+Tracking+by+PRO+and+BOL&searchType=LTL&trackPro=' + tracking;
        break;
      case 'Estes':
        return 'https://www.estes-express.com/myestes/shipment-tracking/?type=PRO&query=' + tracking;
        break;
      case 'Roadway Express':
        return 'https://my.yrc.com/tools/track/shipments?referenceNumber=' + tracking + '&referenceNumberType=PRO&time=' + time;
        break;
      case 'Southeastern Freight':
        return null;
        break;
      case 'USF Holland':
        return null;
        break;
      case 'Volunteer Express':
        return null;
        break;
      case 'UPS':
        return 'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=' + tracking;
        break;
      case 'FedEx':
        return 'http://www.fedex.com/Tracking?tracknumbers=' + tracking + '&cntry_code=us&clienttype=ivother&';
        break;
      case 'Old Dominion':
        return null;
        break;
    }
    return null;
  }
}